import gql from 'graphql-tag'

export const GET_POINTS = gql`
  query GetPoints($q: Any) {
    getPoints(q: $q) {
      _id
      name
      radius
      address
      active
      location {
        type
        coordinates
      }
      owner
      type
      clasification_id
      company_id
      created_by
      created_at
      updated_by
      updated_at
      tags
    }
  }
`